import { z } from 'zod'

export const processTransferSchema = z.object({
	specialty: z.string().min(1, 'Required'),
	reason: z.string().min(1, 'Required'),
})
